import type { Address } from 'viem';

// Chainlink price feed aggregators, verified on-chain (description() +
// latestRoundData()) against the live testnet before wiring in — these are
// real market prices, independent of our own (mostly empty) AMM pools.
export const CHAINLINK_FEEDS: Record<number, Record<string, Address>> = {
  97: {
    BNB: '0x2514895c72f50D8bd4B4F9b1110F0D6bD2c97526',
    BTCB: '0x5741306c21795FdCBb9b265Ea0255F499DFe515C',
    ETH: '0x143db3CEEfbdfe5631aDD3E50f7614B6ba708BA7',
    BUSD: '0x9331b55D9830EF609A2aBCfAc0FBCE050A52fdEa',
  },
};

export function getChainlinkFeed(symbol: string, chainId: number): Address | undefined {
  return CHAINLINK_FEEDS[chainId]?.[symbol];
}

export const AGGREGATOR_V3_ABI = [
  { type: 'function', name: 'description', stateMutability: 'view', inputs: [], outputs: [{ type: 'string' }] },
  { type: 'function', name: 'decimals', stateMutability: 'view', inputs: [], outputs: [{ type: 'uint8' }] },
  {
    type: 'function',
    name: 'latestRoundData',
    stateMutability: 'view',
    inputs: [],
    outputs: [
      { name: 'roundId', type: 'uint80' },
      { name: 'answer', type: 'int256' },
      { name: 'startedAt', type: 'uint256' },
      { name: 'updatedAt', type: 'uint256' },
      { name: 'answeredInRound', type: 'uint80' },
    ],
  },
  {
    type: 'function',
    name: 'getRoundData',
    stateMutability: 'view',
    inputs: [{ name: 'roundId', type: 'uint80' }],
    outputs: [
      { name: 'roundId', type: 'uint80' },
      { name: 'answer', type: 'int256' },
      { name: 'startedAt', type: 'uint256' },
      { name: 'updatedAt', type: 'uint256' },
      { name: 'answeredInRound', type: 'uint80' },
    ],
  },
  // EACAggregatorProxy phase helpers — let us walk into previous aggregator
  // phases for deeper history (see useChainlinkHistory).
  { type: 'function', name: 'phaseId', stateMutability: 'view', inputs: [], outputs: [{ type: 'uint16' }] },
  {
    type: 'function',
    name: 'phaseAggregators',
    stateMutability: 'view',
    inputs: [{ name: 'phaseId', type: 'uint16' }],
    outputs: [{ type: 'address' }],
  },
  // underlying aggregator: raw (un-phased) latest round id
  { type: 'function', name: 'latestRound', stateMutability: 'view', inputs: [], outputs: [{ type: 'uint256' }] },
] as const;
